import { useRef } from 'react';

export default useRef;
